import {Body, Box, Heading} from '@dagster-io/ui-components';

import AnimatedCheck from '@/components/AnimatedCheck';

export default function EmailSentConfirmation({description}: {description: string}) {
  return (
    <Box flex={{direction: 'column', gap: 12, alignItems: 'center'}}>
      <Box margin={{bottom: 24}} style={{width: '80px', height: '80px'}}>
        <AnimatedCheck />
      </Box>
      <Heading size={16} weight={600}>
        Check your inbox.
      </Heading>
      <Body>{description}</Body>
    </Box>
  );
}
